import styleInject from '#style-inject';styleInject(".GifPickerReact .gpr-body{display:flex;flex:1;min-height:0}\n")